export default __webpack_public_path__ + "images/MS.ebbc21b.png";